import { render, staticRenderFns } from "./cm-embarcador.vue?vue&type=template&id=42aeaab8&scoped=true&"
import script from "./cm-embarcador.vue?vue&type=script&lang=js&"
export * from "./cm-embarcador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42aeaab8",
  null
  
)

export default component.exports